import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

const dtReportsConfig = dtConfig[ModulesMap.REPORTS]

function getReportsCultures(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS,
		dtReportsConfig[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_CULTURES],
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		}
	)
}

function getReportsFields(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS,
		dtReportsConfig[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_FIELDS],
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		}
	)
}

function getReportsMaterialsVolumes(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS,
		dtReportsConfig[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_MATERIALS_VOLUMES],
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		}
	)
}

function getReportsProductVolumes(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS,
		dtReportsConfig[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_PRODUCT_VOLUMES],
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		}
	)
}

function getReportsRelatedObjects(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS,
		dtReportsConfig[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_RELATED_OBJECTS],
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		}
	)
}

export default {
	getReportsCultures,
	getReportsFields,
	getReportsMaterialsVolumes,
	getReportsProductVolumes,
	getReportsRelatedObjects,
}
